export default function FAQSection() {
  const faqs = [
    {
      q: 'What is a Superbuy Spreadsheet?',
      a: 'A Superbuy Spreadsheet is a curated, organized collection of product links sourced from various platforms, designed to help shoppers quickly find and compare items across categories like shoes, clothing, accessories, and more — all in one convenient spreadsheet format.',
    },
    {
      q: 'How often is the spreadsheet updated?',
      a: 'Our Superbuy Spreadsheet is updated on a daily basis to ensure all links remain active, prices are current, and new trending products are added regularly. We also perform weekly quality checks across all categories.',
    },
    {
      q: 'Is the Superbuy Spreadsheet free to use?',
      a: 'Yes, the Superbuy Spreadsheet is completely free to browse and use. Simply visit our main platform to access all categories and start discovering curated product links instantly.',
    },
    {
      q: 'How many products are in the spreadsheet?',
      a: 'Our Superbuy Spreadsheet currently features over 50,000 hand-picked products spanning more than 100 categories, from popular sneakers and hoodies to accessories, bags, and fragrances.',
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-6">
              Support
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              Frequently Asked Questions
              <br />
              About Superbuy Spreadsheet
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-[480px]">
              Everything you need to know about using our curated spreadsheet to find the best product links and streamline your shopping experience.
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-foreground-900 rounded-3xl p-8 md:p-10">
              <div className="space-y-6">
                {faqs.map((faq, i) => (
                  <div key={i} className={i < faqs.length - 1 ? 'pb-6 border-b border-white/10' : ''}>
                    <h4 className="text-white font-semibold text-base mb-2 font-heading">
                      {faq.q}
                    </h4>
                    <p className="text-white/65 text-sm leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between mt-8 pt-6 border-t border-white/10">
                <div>
                  <p className="text-white/50 text-xs">Last Updated: January 2026</p>
                  <p className="text-white/50 text-xs mt-1">Safety Policy</p>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/15 text-white text-xs font-semibold rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
                >
                  View All FAQs
                  <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}